import * as React from "react";
import { forwardRef } from "react";
const SvgNext = (props, ref) => <svg width="1em" height="1em" fill="none" stroke="currentColor" viewBox="0 0 24 24" ref={ref} {...props}><path d="m9 18 6-6-6-6" /></svg>;
const ForwardRef = forwardRef(SvgNext);
export default ForwardRef;